import { BroadcastChannel } from 'broadcast-channel';
import type { TBankAuthPayload } from 'src/components/AuthNew/hooks/useTBankAuth';
import { isTelegramWebApp } from 'src/helpers/isTelegram';
import { getPathFromState } from './utils';

const isWebView = window.is_webview || false;

export const TBankHandler = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const code = urlParams.get('code');
  const state = urlParams.get('state') || '';
  const sessionState = urlParams.get('session_state');
  const error = urlParams.get('error');

  const pathFromState = getPathFromState(state);
  // TODO после того, как откроется wl-главная в Нексте, заменить фолбэк путь на '/'
  const targetPath = pathFromState || '/main';

  // Обработчик для TBank авторизации с редиректом (WebView, Telegram, или когда в state есть путь)
  const handleRedirectFlow = () => {
    const newUrl = new URL(`${window.location.origin}${targetPath}`);

    if (code && sessionState) {
      newUrl.searchParams.set('code', code);
      newUrl.searchParams.set('state', state);
      newUrl.searchParams.set('session_state', sessionState);
    } else if (!isWebView && !isTelegramWebApp) {
      // Если не webView/telegram и нет параметров - добавляем error
      newUrl.searchParams.set('error', error || 'auth_failed');
    }
    // Для WebView/Telegram без параметров - просто редиректим без параметров
    window.location.replace(newUrl.toString());
  };
  /**
   * Обработчик для TBank авторизации в обычном браузере
   */
  const handleBrowserFlow = () => {
    const channel = new BroadcastChannel('auth-tbank-code');

    const payload = [
      ...new URLSearchParams(window.location.search).entries(),
    ].reduce((acc, paramTuple) => {
      // eslint-disable-next-line prefer-destructuring
      acc[paramTuple[0]] = paramTuple[1];
      return acc;
    }, {} as TBankAuthPayload);

    payload.redirect_url = `${window.location.origin}/login/tbank`;

    channel.postMessage({
      success: !!(payload.code && payload.session_state),
      payload,
    });

    setTimeout(() => {
      window.close();
    }, 250);
  };

  if (isWebView || isTelegramWebApp || pathFromState) {
    handleRedirectFlow();
  } else {
    handleBrowserFlow();
  }
};
